enum HTTPStatus {
  Accepted = 202,
  Empty = 0,
  OK = 200,
}

export default HTTPStatus;
